import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => {
  return {
    assignedLife365DeviceStatus: {
      display: 'flex',
    },
  }
})
